import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {doTvActivationCodeRecovery, prepareActivationCodeRecovery} from './TvActivationCodeRecoveryBlockSlice';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {isMobile} from 'react-device-detect';

const RecoveryButton = (props) => {
  let cssMobile = isMobile ? ' ismobile' : '';
  return (
    <div className='recovery-button-view'>
      <div>
        <div className={'caption' + cssMobile}>
          <div>שחזור קוד הפעלה ל{window.Config.brand_Name_HE} TV</div>
        </div>
        <div className={'caption-2' + cssMobile}>קל לשחזר את קוד ההפעלה - צריך רק ללחוץ על הכפתור ונשלח לך את הקוד לטלפון ולמייל</div>
      </div>
      <div className='recovery-button-wrapper'>
        <BtnSubmit text='שלחו לי את הקוד' formid='recovery-button' role='button' onclick={() => onClickHandler(props)} />
      </div>
    </div>
  );
};

const onClickHandler = (data) => {
  data.prepareActivationCodeRecovery();
  data.doTvActivationCodeRecovery(data.selectedCustomer);
};

const mapStateToProps = (state) => {
  return {
    isSuccsess: state.TvActivationCodeRecovery.isSuccsess,
    selectedCustomer: state.TvActivationCodeRecovery.selectedCustomer,
  };
};

const mapDispatchToProps = {
  doTvActivationCodeRecovery,
  prepareActivationCodeRecovery,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecoveryButton);
